(function () {
  if (customElements.get('count-up-stats')) return;

  customElements.define('count-up-stats', class extends HTMLElement {
    connectedCallback() {
      this.numbers = this.querySelectorAll('[data-count-up]');
      const duration = parseInt(this.style.getPropertyValue('--animation-duration'), 10) || 2000;

      const update = (multiplier) => {
        this.numbers.forEach((element) => {
          element.textContent = Math.round(parseFloat(element.getAttribute('data-count-up')) * multiplier);
        });
      };

      if (window.Shopify?.designMode || window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
        update(1);
        return;
      }

      this.observer = new IntersectionObserver((entries) => {
        if (!entries[0].isIntersecting) return;

        this.observer.disconnect();
        const startTime = performance.now();

        const frame = (currentTime) => {
          const progress = Math.min(Math.max((currentTime - startTime) / duration, 0), 1);
          update(1 - Math.pow(1 - progress, 3));
          if (progress < 1) requestAnimationFrame(frame);
        };

        requestAnimationFrame(frame);
      }, { threshold: 0.25 });

      this.observer.observe(this);
    }

    disconnectedCallback() {
      this.observer?.disconnect();
    }
  });
})();
